import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@repo/data-gql-core";

import type {
    getLearnerKhanmigoEligibility,
    getLearnerKhanmigoEligibilityVariables,
} from "./__graphql-types__/getLearnerKhanmigoEligibility.ts";
import type {
    getParentKhanmigoEligibility,
    getParentKhanmigoEligibilityVariables,
} from "./__graphql-types__/getParentKhanmigoEligibility.ts";

export const PARENT_KHANMIGO_ELIGIBILITY_QUERY: GqlOperation<
    getParentKhanmigoEligibility,
    getParentKhanmigoEligibilityVariables
> = gqlOp(gql`
    query getParentKhanmigoEligibility($targetKaid: String!) {
        user(kaid: $targetKaid) {
            id
            aiGuideDisabledReason
            aiGuideAccessPlans {
                id
                enrollmentGroup
                isActive
            }
        }
    }
`);

export const LEARNER_KHANMIGO_ELIGIBILITY_QUERY: GqlOperation<
    getLearnerKhanmigoEligibility,
    getLearnerKhanmigoEligibilityVariables
> = gqlOp(gql`
    query getLearnerKhanmigoEligibility {
        user {
            id
            aiGuideDisabledReason
            aiGuideActiveEnrollmentGroups
        }
    }
`);
